<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-form-item prop="name" label="Название отчета">
        <el-input v-model="formData.name" placeholder="Введите название" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">
          Сгенерировать отчет
        </el-button>
        <el-button @click="cancel">Cancel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'Form',
  data() {
    return {
      formData: {
        name: '',
      },
      rules: {
        name: { required: true, message: 'Заполните поле', trigger: 'blur' },
      },
    }
  },
  methods: {
    cancel() {
      this.clearAndClose()
    },
    onSubmit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('sendForm', this.formData.name)
          this.clearAndClose()
        } else {
          return false
        }
      })
    },
    clearAndClose() {
      this.$refs['form'].resetFields()
      this.$emit('close')
    },
  },
}
</script>

<style scoped></style>
